import { styled } from '@aibi-ui/core';
import { Input } from 'antd';

import { KeyboardEventHandler } from 'react';
import SendButton from './SendButton/SendButton';
import SpeechButton from './SpeechButton/SpeechButton';
const { TextArea } = Input;

// Styled Components
const SenderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 56px;
  border: 1px solid #d3d7dd;
  box-shadow: 0 0 8px 0 rgba(211, 215, 221, 0.2);
  border-radius: 8px;
  transition: all 0.2s ease;

  &:focus-within {
    border-color: #1677ff;
    box-shadow: 0 0 8px 0 rgba(22, 119, 255, 0.2);
  }

  .ant-input {
    margin-left: 4px;
    font-size: 15px;
    border: none !important;
    background: transparent !important;
    &:focus {
      border: none !important;
      box-shadow: none !important;
    }
  }
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 15px;

  .line {
    width: 1px;
    height: 15px;
    background: #e0e0e0;
    margin: 0 16px 0 12px;
  }
`;

export interface SenderProps {
  input: string;
  setInput: (value: string) => void;
  onStop: () => void;
  onSend: (value: string) => void;
  disabledSend?: boolean;
  canStop: boolean;
}

const Sender: React.FC<SenderProps> = ({
  input,
  setInput,
  onStop,
  onSend,
  disabledSend,
  canStop,
}) => {
  const dispatchOnStop = () => onStop();

  const handleSend = () => {
    if (!input || input.length === 0) {
      return;
    }
    onSend(input);
  };

  const handleKeyDown: KeyboardEventHandler<HTMLTextAreaElement> = e => {
    if (e.key === 'Enter' && !e.ctrlKey) {
      e.preventDefault(); // 阻止默认换行
      handleSend();
    } else if (e.key === 'Enter' && e.ctrlKey) {
      e.preventDefault();
      setInput(`${input}\n`);
    }
  };

  return (
    <SenderWrapper>
      <TextArea
        value={input}
        onInput={e => setInput(e.currentTarget.value)}
        autoSize={{ minRows: 1, maxRows: 8 }}
        placeholder="在这里输入，可通过Ctrl+Enter换行，即可向AI助手提问"
        onKeyDown={handleKeyDown}
      />
      <ActionButtons>
        <SpeechButton />
        <div className="line" />
        <SendButton
          handleSend={handleSend}
          onStop={dispatchOnStop}
          canStop={canStop}
          disabled={disabledSend}
        />
      </ActionButtons>
    </SenderWrapper>
  );
};

export default Sender;
